function osCheck() {
  var _p = window.navigator.platform

  if (_p === 'Win32' || _p === 'Windows') {
    return 'windows'
  }

  if (_p === 'Mac68K' || _p === 'MacPPC' || _p === 'Macintosh' || _p === 'MacIntel') {
    return 'mac'
  }

  return 'other'
}

function browserCheck() {
  var Sys = {}
  var ua = navigator.userAgent.toLowerCase()
  var s

  if (ua.match(/rv:([\d.]+)/)) {
    s = ua.match(/rv:([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/msie ([\d.]+)/)) {
    s = ua.match(/msie ([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/trident\/([\d.]+)/)) {
    s = ua.match(/trident\/([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/edge\/([\d.]+)/)) {
    s = ua.match(/edge\/([\d.]+)/)
    Sys.edge = s[1]
  } else if (ua.match(/firefox\/([\d.]+)/)) {
    s = ua.match(/firefox\/([\d.]+)/)
    Sys.firefox = s[1]
  } else if (ua.match(/chrome\/([\d.]+)/)) {
    s = ua.match(/chrome\/([\d.]+)/)
    Sys.chrome = s[1]
  } else if (ua.match(/opera.([\d.]+)/)) {
    s = ua.match(/opera.([\d.]+)/)
    Sys.opera = s[1]
  } else if (ua.match(/version\/([\d.]+).*safari/)) {
    s = ua.match(/version\/([\d.]+).*safari/)
    Sys.safari = s[1]
  }

  // 以下进行测试

  if (Sys.ie) {
    Sys.name = 'IE'
    Sys.version = Sys.ie
  }
  if (Sys.edge) {
    Sys.name = 'Edge'
    Sys.version = Sys.edge
  }
  if (Sys.firefox) {
    Sys.name = 'Firefox'
    Sys.version = Sys.firefox
  }
  if (Sys.chrome) {
    Sys.name = 'Chrome'
    Sys.version = Sys.chrome
  }
  if (Sys.opera) {
    Sys.name = 'Opera'
    Sys.version = Sys.opera
  }
  if (Sys.safari) {
    Sys.name = 'Safari'
    Sys.version = Sys.safari
  }

  return Sys
}

function isBrowserOK() {
  const browser = browserCheck()
  if (browser.name === 'Chrome' || browser.name === 'Safari') {
    return '1'
  } else {
    return '0'
  }
}

function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g)
  if (keys) {
    for (var i = keys.length; i--;) {
      if (['auto', 'username', 'password', 'identity'].indexOf(keys[i]) < 0) {
        setCookie(keys[i], '', -1)
      }
    }
  }
}

function getCookieValue(name) {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return decodeURIComponent(arr[2])
  } else {
    return null
  }
}

function setCookie(name, value, days) {
  let cpUrl = window.ConfigNew ? window.ConfigNew.cpUrl : ''
  let zy = window.location.host.split('.').reverse()
  let cp = cpUrl
    .replace(/(http|https):\/\/([^/]*)\//g, '$2')
    .split('.')
    .reverse()
  let lgt = Math.min(zy.length, cp.length)
  let _domain = ''

  for (var i = 0; i < lgt; i++) {
    if (zy[i] === cp[i]) {
      _domain = '.' + zy[i] + _domain
    } else {
      break
    }
  }

  let expires
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toGMTString()
  } else {
    expires = ''
  }

  document.cookie = name + '=' + value + expires + '; path=/;domain=' + _domain
}

function writeLogParams(param) {
  let _param = ''
  if (getCookieValue('id')) {
    const browser = browserCheck()
    _param = Object.assign(
      {},
      {
        accessToken: getCookieValue('accessToken'),
        customerInfoId: getCookieValue('customerInfoId'),
        userId: getCookieValue('id'),
        userRoleType: getCookieValue('userRoleType'),
        actionOrigin: 1, // 动作来源 1.练习系统 2.测评系统 3内容系统 4.前端 等
        action: '', // 动作（操作）名称 标签 不超过
        pushParam: '', // 执行该动作（操作）的附加信息或者参数 如书本名称 建议json格式不超过255长度
        clientType: 1, // 客户端类型 0.未传或未知 1.Web 2.IOS 3.Android
        clientVersion: getCookieValue('clientVersion'),
        serverVersion: getCookieValue('serverVersion'),
        clientInfo: browser.name + ' ' + browser.version,
        userName: getCookieValue('username'),
        fullName: decodeURIComponent(getCookieValue('fullName')) || '',
        loginFrom: getCookieValue('loginFrom'),
        timestamp: Date.now(),
        logType: 1, // 日期类型 1正常日志 0异常日志
        schoolId: getCookieValue('schoolId') || '',
        categoryId: getCookieValue('categoryId') || '',
        scId: getCookieValue('classId') || '',
        resId: ''
      },
      param
    )
    _param.pushParam = JSON.stringify(_param.pushParam)
  } else if (localStorage.getItem('kami_track')) {
    const track = JSON.parse(localStorage.getItem('kami_track'))
    _param = Object.assign({}, track, param)
    _param.timestamp = Date.now()
    _param.fullName = decodeURIComponent(_param.fullName)
    _param.pushParam = JSON.stringify(_param.pushParam)
  } else {
    // TODO
  }

  return _param
}

let urlSet = {
  examReport: '/web/models/Report/default/self.php',
  rank: '/web/models/RankMessage/self.php'
}

function banBackSpace(e) {
  let ev = e || window.event
  // 各种浏览器下获取事件对象
  let obj = ev.relatedTarget || ev.srcElement || ev.target || ev.currentTarget
  // 按下Backspace键
  if (ev.keyCode === 8) {
    // 标签名称
    let tagName = obj.nodeName
    // 如果标签不是input或者textarea则阻止Backspace
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
      ev.preventDefault()
      return
    }

    // 标签类型
    let tagType = obj.type.toUpperCase()
    // input标签除了下面几种类型，全部阻止Backspace
    if (
      tagName === 'INPUT' &&
      tagType !== 'TEXT' &&
      tagType !== 'TEXTAREA' &&
      tagType !== 'PASSWORD'
    ) {
      ev.preventDefault()
      return
    }

    // input或者textarea输入框如果不可编辑则阻止Backspace
    if (
      (tagName === 'INPUT' || tagName === 'TEXTAREA') &&
      (obj.readOnly === true || obj.disabled === true)
    ) {
      ev.preventDefault()
    }
  }
}

export default {
  osCheck,
  browserCheck,
  isBrowserOK,
  clearAllCookie,
  getCookieValue,
  setCookie,
  writeLogParams,
  urlSet,
  banBackSpace
}
export function getBrowserInfoPlus() {
  var document = window.document
  var navigator = window.navigator
  var agent = navigator.userAgent.toLowerCase()
  // IE8+支持.返回浏览器渲染当前文档所用的模式
  // IE6,IE7:undefined.IE8:8(兼容模式返回7).IE9:9(兼容模式返回7||8)
  // IE10:10(兼容模式7||8||9)
  var IEMode = document.documentMode
  // chorme
  var chrome = window.chrome || false
  var System = {
    // user-agent
    agent: agent,
    // 是否为IE
    isIE: /msie/.test(agent),
    // Gecko内核
    isGecko: agent.indexOf('gecko') > 0 && agent.indexOf('like gecko') < 0,
    // webkit内核
    isWebkit: agent.indexOf('webkit') > 0,
    // 是否为标准模式
    isStrict: document.compatMode === 'CSS1Compat',
    // 是否支持subtitle
    supportSubTitle: function () {
      return 'track' in document.createElement('track')
    },
    // 是否支持scoped
    supportScope: function () {
      return 'scoped' in document.createElement('style')
    },
    // 获取IE的版本号
    ieVersion: function () {
      try {
        return agent.match(/msie ([\d.]+)/)[1] || 0
      } catch (e) {
        console.log('error')
        return IEMode
      }
    },
    // Opera版本号
    operaVersion: function () {
      try {
        if (window.opera) {
          return agent.match(/opera.([\d.]+)/)[1]
        } else if (agent.indexOf('opr') > 0) {
          return agent.match(/opr\/([\d.]+)/)[1]
        }
      } catch (e) {
        console.log('error')
        return 0
      }
    },
    _mime: function (option, value) {
      var mimeTypes = navigator.mimeTypes
      for (var mt in mimeTypes) {
        if (mimeTypes[mt][option] === value) {
          return true
        }
      }
      return false
    },
    // 描述:version过滤.如31.0.252.152 只保留31.0
    versionFilter: function () {
      if (arguments.length === 1 && typeof arguments[0] === 'string') {
        var version = arguments[0]
        var start = version.indexOf('.')
        if (start > 0) {
          var end = version.indexOf('.', start + 1)
          if (end !== -1) {
            return version.substr(0, end)
          }
        }
        return version
      } else if (arguments.length === 1) {
        return arguments[0]
      }
      return 0
    }
  }

  try {
    // 浏览器类型(IE、Opera、Chrome、Safari、Firefox)
    System.type = System.isIE
      ? 'IE'
      : window.opera || agent.indexOf('opr') > 0
        ? 'Opera'
        : agent.indexOf('chrome') > 0
          ? 'Chrome'
          : window.openDatabase
            ? 'Safari'
            : agent.indexOf('firefox') > 0
              ? 'Firefox'
              : 'unknow'

    // 版本号
    System.version =
      System.type === 'IE'
        ? System.ieVersion()
        : System.type === 'Firefox'
          ? agent.match(/firefox\/([\d.]+)/)[1]
          : System.type === 'Chrome'
            ? agent.match(/chrome\/([\d.]+)/)[1]
            : System.type === 'Opera'
              ? System.operaVersion()
              : System.type === 'Safari'
                ? agent.match(/version\/([\d.]+)/)[1]
                : '0'

    // 浏览器外壳
    System.shell = function () {
      // 遨游浏览器
      if (agent.indexOf('maxthon') > 0) {
        System.version = agent.match(/maxthon\/([\d.]+)/)[1] || System.version
        return '傲游浏览器'
      }
      // QQ浏览器
      if (agent.indexOf('qqbrowser') > 0) {
        System.version = agent.match(/qqbrowser\/([\d.]+)/)[1] || System.version
        return 'QQ浏览器'
      }

      // 搜狗浏览器
      if (agent.indexOf('se 2.x') > 0) {
        return '搜狗浏览器'
      }

      // Chrome:也可以使用window.chrome && window.chrome.webstore判断
      if (chrome && System.type !== 'Opera') {
        var external = window.external

        // 猎豹浏览器:或者agent.indexOf("lbbrowser")>0
        if (external && 'LiebaoGetVersion' in external) {
          return '猎豹浏览器'
        }
        // 百度浏览器
        if (agent.indexOf('bidubrowser') > 0) {
          System.version =
            agent.match(/bidubrowser\/([\d.]+)/)[1] || agent.match(/chrome\/([\d.]+)/)[1]
          return '百度浏览器'
        }
        // 360极速浏览器和360安全浏览器
        if (System._mime('type', 'application/vnd.chromium.remoting-viewer')) {
          // object.key()返回一个数组.包含可枚举属性和方法名称
          var storeKeyLen = Object.keys(chrome.webstore).length
          // var v8Locale = 'v8Locale' in window
          return storeKeyLen > 1 ? '360极速浏览器' : '360安全浏览器'
        }
        return 'Chrome'
      }
      return System.type
    }

    // 浏览器名称(如果是壳浏览器,则返回壳名称)
    System.name = System.shell()
    // 对版本号进行过滤过处理
    System.version = System.versionFilter(System.version)
  } catch (e) {
    console.log('error')
  }
  return {
    client: System
  }
}



// WEBPACK FOOTER //
// ./src/util/Util.js